export default {
    state: {
        unreadMessages: null
    },
    mutations: {
        setUnreadMessages(state, payload) {
            state.unreadMessages = payload;
        }
    },
    actions: {
        loadMessages(state, {params}) {
            return this.dispatch('sendRequest', {path: '/chat/message', params});
        },
        createMessage(state, {data}) {
            return this.dispatch('sendRequest', {path: '/chat/message', data, method: 'post'});
        },
        updateMessage(state, {data, id}) {
            return this.dispatch('sendRequest', {path: '/chat/message/'+id, data, method: 'post'});
        },
        deleteMessage(state, {id}) {
            return this.dispatch('sendRequest', {path: '/chat/message/'+id, method: 'delete'});
        },
        countUnreadMessages() {
            return this.dispatch('sendRequest', {path: '/chat/message-count-unread'});
        }
    }
}